import { t } from "i18next";

import TitledPage from "@/modules/common/components/layout/pages/TitledPage";

const BannersPage = () => {
  return <TitledPage title={t("Admin Banners")}></TitledPage>;
};

export default BannersPage;
